/* eslint-disable */

import { Container, Row } from "react-bootstrap";
import { useReport } from "../ReportContext";
import NextPrevLinks from "../../components/NextPrevLinks";
import SectionIntroduction from "../components/SectionIntroduction";

const ThoughtsFeelings = () => {
	const { reportContent: { acf: { thoughts_wants_feelings } } } = useReport();
	return (
		<div className="report-view">
			<SectionIntroduction text={thoughts_wants_feelings.introduction} />

			<hr />

			<h2>Information about you Thoughts, Wants and Feelings</h2>
			<div className="d-flex gap-4 mt-4">
				<Container className="bg-white d-flex gap-3 rounded-3">
					<p>Feelings</p>
					<p>34.01%</p>
				</Container>
				<Container className="bg-white d-flex gap-3 rounded-3">
					<p>Thoughts</p>
					<p>35.01%</p>
				</Container>
				<Container className="bg-white d-flex gap-3 rounded-3">
					<p>Wants</p>
					<p>30.98%</p>
				</Container>
			</div>
			<Container className="bg-white d-flex flex-column gap-3 rounded-3 my-4">
				<h3>Balance</h3>
				<p>Chart here</p>
			</Container>
			<h3>Your Balanced Reliance on Thoughts, Wants Feelings is at the <span className="text-rating" style={{color: "var(--bs-success)"}}>"Very High"</span> Level</h3>
			<p>Rating-specific content here...</p>

			<hr />
			
			<NextPrevLinks />
		</div>
	);
};

export default ThoughtsFeelings;
